import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import RichTextEditor from './RichTextEditor';

const ThemedRichTextEditor = (props) => {
  const theme = useTheme();

  useEffect(() => {
    // Устанавливаем CSS переменные для темы
    const root = document.documentElement;
    
    // Используем более светлые цвета для лучшей читаемости
    const textColor = theme.palette.mode === 'dark' ? theme.palette.text.primary : '#424242';
    
    root.style.setProperty('--mui-palette-text-primary', textColor);
    root.style.setProperty('--mui-palette-text-secondary', theme.palette.text.secondary);
    root.style.setProperty('--mui-palette-background-paper', theme.palette.background.paper);
    root.style.setProperty('--mui-palette-background-default', theme.palette.background.default);
    root.style.setProperty('--mui-palette-primary-main', theme.palette.primary.main);
    root.style.setProperty('--mui-palette-divider', theme.palette.divider);
    root.style.setProperty('--mui-palette-action-hover', theme.palette.action.hover);
    
  }, [theme]);

  return <RichTextEditor {...props} />;
};

export default ThemedRichTextEditor;
